import React, {FC, useState} from 'react';
import {Button, Flex, Text} from '@priority-software/priority-style-react';
import texts from '../../texts';
import styles from './ShowMoreText.module.scss';

export type ShowMoreTextProps = {
    text: string;
    extendedText: string;
};

export const ShowMoreText: FC<ShowMoreTextProps> = ({text, extendedText}) => {
    const [showMore, setShowMore] = useState(false);

    return (
        <Flex direction={'column'}>
            <Text skin={'paragraph-1'} textColor={'primary-700'} tag={'span'}>
                {text}
                {showMore ? `\n${extendedText}` : ''}
            </Text>
            <Button
                componentClasses={styles.button}
                skin={'text'}
                onClick={() => setShowMore(!showMore)}
            >
                {!showMore ? texts['show_more'] : texts['show_less']}
            </Button>
        </Flex>
    );
};
